'use client';

import * as React from 'react';
import { Toaster as ChakraToaster, Portal, Spinner, Stack, Toast, ToastOptions, createToaster } from '@chakra-ui/react';
import { useAppDispatch } from 'store/hooks';
import { deleteNotification } from '../../store/notificationSlice';

export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
});

export function Toaster() {
  const dispatch = useAppDispatch();
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {(toast: ToastOptions) => (
          <Toast.Root width={{ md: 'sm' }}>
            {toast.type === 'loading' ? <Spinner size="sm" color="blue.solid" /> : <Toast.Indicator />}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.closable && (
              <Toast.CloseTrigger
                onClick={() => toast.id && dispatch(deleteNotification(toast.id))}
              ></Toast.CloseTrigger>
            )}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
}
